import { FC } from 'react';
import { Image } from '~/components/image';
import { TArticleDetail, TComment } from 'shared/models';
import useReflowClick from '~/utils/use-reflow-click';
import { ClickPosition, ClickPositionPrefix } from '~/utils/click-position';
import { useActiveToCurrentPage } from '~/utils/active/use-active-to-current-page';
import { useActiveToArticle } from '~/utils/active/use-active-to-article';
import { useCommentImage } from './use-comment-image';

import './style.scss';

interface ICommentImageProps {
  comment: TComment;
  positionPrefix?: ClickPositionPrefix;
  currentArticle?: TArticleDetail;
}

export const CommentImage: FC<ICommentImageProps> = (props) => {
  const { comment, currentArticle, positionPrefix = ClickPositionPrefix.none } = props;
  const commentImage = useCommentImage(comment);
  const activeToCurrentPage = currentArticle ? useActiveToArticle(currentArticle) : useActiveToCurrentPage();

  if (!commentImage) {
    return null;
  }

  const { height, width, src, alt } = commentImage;

  const handleClickImage = useReflowClick(
    {
      reflowBehavior: () => {
        activeToCurrentPage([positionPrefix, ClickPosition.comment_image]);
      },
      defaultBehavior: () => {
        activeToCurrentPage([positionPrefix, ClickPosition.comment_image]);
      },
      clickEvent: () => ({
        current_position: positionPrefix + ClickPosition.comment_reply,
        page_click_id: comment.commentId,
      }),
    },
    [activeToCurrentPage, comment],
  );

  return (
    <div
      className="comment-image"
      onClick={handleClickImage}
      style={{
        height,
        width,
      }}
    >
      <Image src={src} alt={alt} />
    </div>
  );
};
